import React from "react";
import { Box } from "@mui/material";
import arrowIcon from "@iconify/icons-mdi/arrow-right";
import { InlineIcon } from "@iconify/react";

interface OcDataTableBodyCellArrowIconProps {
  row: {
    date: string;
    icons?: {
      arrow?: boolean;
    };
    [key: string]: any;
  };
  isNotExaminer: boolean;
  currentMonth: string;
  periodMonth: string;
  handleSelectRow: (params: { action: string; row: any }) => void;
  buttonStyle?: React.CSSProperties;
}

export const OcDataTableBodyCellArrowIcon: React.FC<
  OcDataTableBodyCellArrowIconProps
> = ({
  row,
  isNotExaminer,
  currentMonth,
  periodMonth,
  handleSelectRow,
  buttonStyle,
}) => {
  if (isNotExaminer && currentMonth === periodMonth) return null;
  if (row?.icons?.arrow === false) return null;
  return (
    <Box
      onClick={() => handleSelectRow({ action: "show", row: row })}
      style={buttonStyle}
    >
      <InlineIcon
        width="24px"
        height="24px"
        id={`show-${new Date(row?.date).getDate()}`}
        icon={arrowIcon}
      />
    </Box>
  );
};

export default OcDataTableBodyCellArrowIcon;
